import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Individual widget components
const TotalTradesWidget = ({ totalTrades }) => (
  <Card style={{ minHeight: '100px' }}>
    <MDBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" pt={2} px={2} height="100%">
      <MDTypography variant="h6" fontWeight="medium">
        Total Trades
      </MDTypography>
      <MDTypography variant="h4" fontWeight="bold">
        {totalTrades}
      </MDTypography>
    </MDBox>
  </Card>
);

TotalTradesWidget.propTypes = {
  totalTrades: PropTypes.number.isRequired,
};

const TotalPnLWidget = ({ totalPnL }) => (
  <Card style={{ minHeight: '100px' }}>
    <MDBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" pt={2} px={2} height="100%">
      <MDTypography variant="h6" fontWeight="medium">
        Total PnL
      </MDTypography>
      <MDTypography variant="h4" fontWeight="bold">
        ${totalPnL.toFixed(2)}
      </MDTypography>
    </MDBox>
  </Card>
);

TotalPnLWidget.propTypes = {
  totalPnL: PropTypes.number.isRequired,
};

const AverageRRWidget = ({ averageRR }) => (
  <Card style={{ minHeight: '100px' }}>
    <MDBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" pt={2} px={2} height="100%">
      <MDTypography variant="h6" fontWeight="medium">
        Average RR
      </MDTypography>
      <MDTypography variant="h4" fontWeight="bold">
        {averageRR.toFixed(2)}
      </MDTypography>
    </MDBox>
  </Card>
);

AverageRRWidget.propTypes = {
  averageRR: PropTypes.number.isRequired,
};

const AverageHoldTimeWidget = ({ averageHoldTime }) => (
  <Card style={{ minHeight: '100px' }}>
    <MDBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" pt={2} px={2} height="100%">
      <MDTypography variant="h6" fontWeight="medium">
        Average Hold Time
      </MDTypography>
      <MDTypography variant="h4" fontWeight="bold">
        {averageHoldTime.toFixed(2)} hrs
      </MDTypography>
    </MDBox>
  </Card>
);

AverageHoldTimeWidget.propTypes = {
  averageHoldTime: PropTypes.number.isRequired,
};

const BestSessionWidget = ({ bestSession }) => (
  <Card style={{ minHeight: '100px' }}>
    <MDBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" pt={2} px={2} height="100%">
      <MDTypography variant="h6" fontWeight="medium">
        Best Session
      </MDTypography>
      <MDTypography variant="h4" fontWeight="bold">
        {bestSession}
      </MDTypography>
    </MDBox>
  </Card>
);

BestSessionWidget.propTypes = {
  bestSession: PropTypes.string.isRequired,
};

const BestSymbolWidget = ({ bestSymbol }) => (
  <Card style={{ minHeight: '100px' }}>
    <MDBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" pt={2} px={2} height="100%">
      <MDTypography variant="h6" fontWeight="medium">
        Best Symbol
      </MDTypography>
      <MDTypography variant="h4" fontWeight="bold">
        {bestSymbol}
      </MDTypography>
    </MDBox>
  </Card>
);

BestSymbolWidget.propTypes = {
  bestSymbol: PropTypes.string.isRequired,
};

// Main component to render all widgets
const WidgetsBacktesting = ({ metrics }) => {
  const {
    totalTrades,
    totalPnL,
    averageRR,
    averageHoldTime,
    bestSession,
    bestSymbol
  } = metrics;

  console.log('Metrics in WidgetsBacktesting:', metrics);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <TotalTradesWidget totalTrades={totalTrades} />
      </Grid>
      <Grid item xs={12} md={6}>
        <TotalPnLWidget totalPnL={totalPnL} />
      </Grid>
      <Grid item xs={12} md={6}>
        <AverageRRWidget averageRR={averageRR} />
      </Grid>
      <Grid item xs={12} md={6}>
        <AverageHoldTimeWidget averageHoldTime={averageHoldTime} />
      </Grid>
      <Grid item xs={12} md={6}>
        <BestSessionWidget bestSession={bestSession} />
      </Grid>
      <Grid item xs={12} md={6}>
        <BestSymbolWidget bestSymbol={bestSymbol} />
      </Grid>
    </Grid>
  );
};

WidgetsBacktesting.propTypes = {
  metrics: PropTypes.shape({
    totalTrades: PropTypes.number.isRequired,
    totalPnL: PropTypes.number.isRequired,
    averageRR: PropTypes.number.isRequired,
    averageHoldTime: PropTypes.number.isRequired,
    bestSession: PropTypes.string.isRequired,
    bestSymbol: PropTypes.string.isRequired,
  }).isRequired,
};

export default WidgetsBacktesting;